import * as cryptoJS from "crypto-js";

import { CustomerPortalToken } from "./checkTokenCustomerInvite";

export const createTokenCustomerPortalToPathname = (
  customerPortalToken: CustomerPortalToken,
  secretKeyPassword?: string
) => {
  try {
    if (customerPortalToken && secretKeyPassword) {
      let customerPortalTokenEncrypted = cryptoJS.AES.encrypt(
        JSON.stringify(customerPortalToken),
        secretKeyPassword
      ).toString();

      customerPortalTokenEncrypted = customerPortalTokenEncrypted?.replace(/\//gi, "-");

      return customerPortalTokenEncrypted;
    }
  } catch (error) {
    console.error(error);
  }
};
